import styled from 'styled-components';
import React from 'react';
import { theme } from '../../utilsClient/cssHelpers';
import LanguageSelector from './LanguageSelector';

const StyledLanguageSelector = styled(LanguageSelector)`
  &&&&& {
    .ant-select-selector {
      background: none !important;
      box-shadow: none !important;
      border: 0 !important;
    }
    .ant-select-selector,
    .ant-select-arrow {
      color: ${theme('color.onBackground')};
    }
  }
`;

const LanguageSelectorSimple = (props) => {
  return (
    <StyledLanguageSelector
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
};

export default LanguageSelectorSimple;
